import React from 'react'

export default function TrustSafety() {
  return (
   <>
   
        {/* TRUST & SAFETY */}
      <section className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-h2 md:text-4xl font-bold text-trogoBlue text-center">
            Built on Trust & Safety
          </h2>
          <div className="w-20 h-1 bg-trogoOrange mx-auto mt-3 mb-10 rounded"></div>

          <ul className="grid md:grid-cols-2 gap-6 text-lg text-gray-700">
            {[
              "Verified drivers & vehicles",
              "Document verification & admin approval",
              "Secure digital payments",
              "Transparent pricing",
              "Real-time ride tracking",
              "Safe & reliable experience"
            ].map((text, i) => (
              <li key={i} className="flex gap-3 items-start">
                <i className="fa-solid fa-shield text-trogoOrange mt-1"></i>
                {text}
              </li>
            ))}
          </ul>
        </div>
      </section>
   </>
  )
}